import React from "react";
import Table from "../../Common/Table";
import { getPath } from "../../../utils";
import BlankState from "../../Common/BlankState";
import TableFields from "../../../constants/GroomingSelfies/TableFields.json";
import TableFieldsOnlineFace from "../../../constants/GroomingSelfies/TableFieldsOnlineFace.json";
import styled from "styled-components";

const GroomingSelfiesList = ({ groomingSelfiesList }) => {
  const [IsOnlineFace, SetIsOnlineFace] = React.useState(false);
  const getFieldValue = (item, key) => {
    if (key === "selfie_url" || (key === "onboarding_image_url" && item[key])) {
      return <Image src={`${item[key]}`} />;
    } else if (key === "created_at" || key === "updated_at") {
      return new Date(item[key]).toLocaleString(undefined, {
        timeZone: "Asia/Kolkata",
      });
    } else if (key === "selfie_type") {
      if (item[key] === "ONLINE_FACE") {
        SetIsOnlineFace(true);
      } else {
        SetIsOnlineFace(false);
      }
      return item[key];
    } else {
      return item[key];
    }
  };

  if (IsOnlineFace) {
    return getPath(groomingSelfiesList, "length", undefined) > 0 ? (
      <Table
        list={groomingSelfiesList}
        fields={TableFieldsOnlineFace}
        getFieldValue={getFieldValue}
      />
    ) : (
      <BlankState />
    );
  } else {
    return getPath(groomingSelfiesList, "length", undefined) > 0 ? (
      <Table
        list={groomingSelfiesList}
        fields={TableFields}
        getFieldValue={getFieldValue}
      />
    ) : (
      <BlankState />
    );
  }
};

const Image = styled.img`
  padding: 2px;
  background-color: white;
  transition: transform .2s;
  width: 120px;
  height: 120px;
  margin: 0 auto;

  &:hover {
    transform: scale(2.5);
`;

export default GroomingSelfiesList;
